<header class="header--page">
    <ul class="header__nav">
        <li>
            <h1><i class="material-icons mvd_alert--label">power_settings_new</i> Session Ended</h1>
        </li>

    </ul>
</header>
<div class="mvd_container">
    <div class="well">
        <h2>ADOT</h2>
        <button class="btn--primary" type="button" (click)="redirectForLogin()">Login</button>
    </div>
</div>